import React, { useState } from 'react';

const ConfigSelector = ({ selectedConfig, onConfigChange, configs }) => {
  const [showPreview, setShowPreview] = useState(false);

  const handleConfigChange = (event) => {
    const configKey = event.target.value;
    onConfigChange(configKey);
    setShowPreview(configKey !== '');
  };

  return (
    <div>
      <div className="form-group">
        <label htmlFor="configSelect">Select Deployment Configuration:</label>
        <select
          id="configSelect"
          value={selectedConfig}
          onChange={handleConfigChange}
        >
          <option value="">Choose a configuration...</option>
          {Object.keys(configs).map(key => (
            <option key={key} value={key}>
              {configs[key].service_name}
            </option>
          ))}
        </select>
      </div>

      {showPreview && selectedConfig && configs[selectedConfig] && (
        <div style={{
          background: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '6px',
          padding: '15px',
          marginBottom: '20px',
          fontFamily: 'Monaco, Menlo, Ubuntu Mono, monospace',
          fontSize: '0.9rem',
          maxHeight: '200px',
          overflowY: 'auto'
        }}>
          <div style={{ 
            marginBottom: '10px', 
            fontWeight: 'bold',
            color: '#495057'
          }}>
            Configuration Preview:
          </div>
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(configs[selectedConfig], null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default ConfigSelector;